import PreviewStylesCss from "../../../styles/PreviewStyles.css";
import TableStyles from "../../../styles/TableStyles.css";
import CommonStyles from "../../../styles/CommonStyles.css";

export const styles = (theme) => ({
  // ...TableStyles,
  ...CommonStyles,

  ...PreviewStylesCss,
  artworkHolder:{
    position:"relative",
    outline:"none",
    "&:hover > button":{
      display:"inline-block",
      opacity:"1"
    },
    "&:focus > button":{
      display:"inline-block",
      outline:"none",
      opacity:"1"
    },
    "&:active > button":{
      display:"inline-block",
      outline:"none",
      opacity:"1"
    },

      "& button":{
        background: "#008135",
        width: "40px",
        height: "40px",
        boxShadow:"0 0 3px #000",
        "&:hover":{
          background: "#000",
        },
        position: "absolute",
        // display:"none",
        opacity:"0",
        right: "45%",
        top: "40%",
        "&.Mui-focusVisible":{
          opacity:"1"
        }
      },
      "&:hover > span":{ 
        opacity:"1"
      },
      "& > span":{
        top: "40%",
    right: "45%",
    width: "40px",
    height: "40px",
    opacity: "0",
    position:" absolute",
      },
      // Added Breakpoints
      [theme.breakpoints.down("sm")]: {
      "& img":{
        width:"100%",
        height:"auto",
      }
      },
      [theme.breakpoints.up("md")]: {
        "& img":{
          width:"100% !important",
          height:"auto !important",
        }
      },
      [theme.breakpoints.up("lg")]: {
        "& img":{
          width:"160px!important",
          height:"160px !important",
        }
      },
  
       
  },
  muLabelsTrackPopOut: {
    minWidth: "170px",
    width:"inerit",
    textTransform: "uppercase",
    color: "#dcdcdc",
    fontSize: "0.7em",
    display: "inline-block",
    verticalAlign: "top",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft:"0"
  },
  muTitle: {
    color: "#fff",
    fontSize: "0.88em",
    fontWeight: "500",
    width: "-webkit-fill-available",
    width:"100%",
    padding: "10px 15px 10px 10px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "0",
    whiteSpace: "nowrap",
  },
  muListWrap: {
    padding: "10px",
    height: " calc(100% - 340px)",
    overflow: "auto",
    position: "absolute",
    width: "100%",
    top: "0",
    overflowX: "hidden",
    background: " #353535",
  },
  nonMCPSPPL: {
  color: "red",
},
  cfStatus:{
    whiteSpace: "nowrap",
  }

});
